import Vue from 'vue'
// @ts-ignore
import App from './App.vue'
import './quasar.js'
import store from './store/index'
import router from './router'
import 'placeholder-loading/dist/css/placeholder-loading.min.css'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBn9vmXgwsHjeVqWSrNq9sMqEztn770MPI',
    installComponents: true,
    v: '3.34'
  }
})

// @ts-ignore
const vue = new Vue({ store, router, render: h => h(App) }).$mount('#app')

// @ts-ignore
vue.$initTenant()

// @ts-ignore
window.__Tenant_Vue = vue

// @ts-ignore
// window._set_base_url('https://pentest.easion.nl/backend/api')

// function sendError (error, message) {
//   store.dispatch('parantion/error/registerError', {
//     message: message,
//     errorTrace: error.response,
//     payload: store.state.survey.activeSurvey,
//     location: location.href,
//     name: packageJSON.name,
//     version: packageJSON.version
//   })
// }
//
// window.onerror = function (message, errorTrace) {
//   console.log('%cERROR: ', 'color: red', message, errorTrace)
//   sendError(message, errorTrace)
// }
//
// axios.interceptors.response.use(undefined, function (error) {
//   console.log('%cERROR - axios: ', 'color: red', error)
//   const errorData = error.response
//   const message = errorData.status + ' - ' + errorData.statusText + ' - ' + errorData.data.message
//   sendError(error, message)
//   return Promise.reject(error)
// })
